export default "__VITE_ASSET__pOeUZ3AS__"